import * as React from "react";
import Svg, { G, Circle, Path, Defs } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
const SVGComponent = (props) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    {...props}
  >
    <G filter="url(#filter0_d_5362_30804)">
      <Circle cx={20} cy={18} r={16} fill="white" />
    </G>
    <Path
      d="M27.8522 13.044C27.2462 11.862 26.6501 10.6703 26.0735 9.46886C25.9073 9.12698 25.7021 9 25.3209 9C21.7635 9.00977 18.2158 9.00977 14.6681 9C14.3065 9 14.1012 9.12698 13.9546 9.43956C13.3585 10.6703 12.7428 11.8816 12.1271 13.1026C12.0293 13.2979 12 13.4933 12 13.7082C12 17.2344 12 21.7705 12 25.2967C12 25.9512 12.0489 26 12.6841 26C15.1274 26 17.5707 26 20.0043 26C22.4476 26 24.8909 26 27.3244 26C27.9304 26 27.989 25.9414 27.9988 25.326C27.9988 21.7998 27.9988 17.2637 27.9988 13.7375C28.0086 13.4933 27.9597 13.2686 27.8522 13.044ZM20.3854 10.0842C20.3854 9.85958 20.4343 9.77167 20.6786 9.77167C22.1544 9.78144 23.6301 9.78144 25.1157 9.77167C25.2525 9.77167 25.3698 9.78144 25.4382 9.92796C25.9464 10.9536 26.4644 11.9792 27.0117 13.083C24.8518 13.083 22.7896 13.083 20.7275 13.083C20.4734 13.083 20.3854 13.0147 20.3952 12.7607C20.3952 11.862 20.3952 10.9731 20.3854 10.0842ZM14.5606 9.95727C14.6388 9.79121 14.7561 9.78144 14.9124 9.78144C16.3882 9.78144 17.8639 9.79121 19.3495 9.78144C19.5645 9.78144 19.6231 9.84982 19.6231 10.0549C19.6133 10.9634 19.6133 11.8718 19.6231 12.7802C19.6231 13.0147 19.5547 13.0928 19.3201 13.083C17.2482 13.0733 15.1665 13.083 13.0066 13.083C13.5539 11.9792 14.0622 10.9731 14.5606 9.95727ZM27.2462 24.8669C27.2462 25.1697 27.1681 25.2381 26.8651 25.2381C22.2912 25.2283 17.7173 25.2283 13.1435 25.2381C12.8503 25.2381 12.7623 25.1795 12.7623 24.8669C12.7721 21.6435 12.7721 17.4298 12.7623 14.2063C12.7623 13.8449 12.9187 13.8254 13.1923 13.8254C15.4695 13.8352 17.7467 13.8254 20.0238 13.8254C22.2814 13.8254 24.5488 13.8352 26.8064 13.8156C27.1387 13.8156 27.2462 13.8938 27.2365 14.2454C27.2365 17.4591 27.2365 21.663 27.2462 24.8669Z"
      fill="#333333"
      stroke="#333333"
      strokeWidth={0.8}
    />
    <Path
      d="M17.7998 16.7998L22.9997 21.9997"
      stroke="#FF2E00"
      strokeWidth={2}
      strokeLinecap="round"
    />
    <Path
      d="M23 16.7998L17.8001 21.9997"
      stroke="#FF2E00"
      strokeWidth={2}
      strokeLinecap="round"
    />
    <Defs />
  </Svg>
);
export default SVGComponent;
